module.exports = __webpack_public_path__ + "static/media/clinica-a-s.b6031621.jpg";